import { useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Spin } from "antd";
import {
	SubmitButtonOverlay,
	ActionContainer,
	ActionItemsContainer,
	FormHeaderComponent,
} from "../../components/styled/common";
import BackComponent from "../../components/BackComponent";
import MainButtonComponent from "../../components/MainButtonComponent";
import VolunteersAboutForm, { applyAboutLocalizableChanges } from "../../components/VolunteersAboutForm";
import { LocalizedContentChanges } from "../../components/LocalizedContentFields";
import { useVolunteersAboutContext } from "../../context/VolunteersAboutContext/VolunteersAboutContext";
import { Culture, VOLUNTEERS_ABOUT_PATH } from "../../context/VolunteersAboutContext/constants";

const EditVolunteersAbout = () => {
	const { id } = useParams<{ id: string }>();
	const {
		updateVolunteersAbout,
		getVolunteersAboutForEdit,
		clearVolunteersAboutFormData,
		volunteersAboutEditForm,
		setVolunteersAboutEditForm,
		operationStatus,
	} = useVolunteersAboutContext();

	const isFetching = operationStatus.type === "loading" && operationStatus.operation === "fetch";

	useEffect(() => {
		if (id) {
			getVolunteersAboutForEdit(id);
		}

		return () => {
			clearVolunteersAboutFormData();
		};
	}, [id, getVolunteersAboutForEdit, clearVolunteersAboutFormData]);

	const handleLocalizableChange = useCallback((culture: Culture, changes: LocalizedContentChanges) => {
		setVolunteersAboutEditForm(prev => (prev ? {
			...prev,
			volunteersAboutLocalizable: applyAboutLocalizableChanges(prev.volunteersAboutLocalizable, culture, changes),
		} : null));
	}, [setVolunteersAboutEditForm]);

	return (
		<>
			<BackComponent text="Koç Gönüllüleri Hakkında Sayfasına Dön" to={VOLUNTEERS_ABOUT_PATH} />
			<ActionContainer>
				<Spin spinning={isFetching}>
					<ActionItemsContainer>
						<FormHeaderComponent>Koç Gönüllüleri Hakkında Güncelleme</FormHeaderComponent>
						{volunteersAboutEditForm && (
							<VolunteersAboutForm
								key={volunteersAboutEditForm.aboutId}
								localizables={volunteersAboutEditForm.volunteersAboutLocalizable}
								isRequired={false}
								onLocalizableChange={handleLocalizableChange}
							/>
						)}
						<SubmitButtonOverlay>
							<MainButtonComponent
								onClick={updateVolunteersAbout}
								type="default"
								disabled={!volunteersAboutEditForm}
								loading={operationStatus.type === "loading" && operationStatus.operation === "update"}
							>
								Güncelle
							</MainButtonComponent>
						</SubmitButtonOverlay>
					</ActionItemsContainer>
				</Spin>
			</ActionContainer>
		</>
	);
};

export default EditVolunteersAbout;
